<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/retail/topic_icon.svg" alt="" />
      <h2>Distribution Logistics</h2>
      <p>
        Distribution facilities are critical as they are centers of national consumer activity; partnering with CESCO enhances your store's value and
        trust.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Department Stores </span>
        <span class="tag"> #Marts </span>
        <span class="tag"> #Convenience Stores </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img :src="require(`@/assets/images/location/retail/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="" />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="" />
            <div class="title">
              <h3>
                Concerns due to
                <br />
                Pests like Cockroaches and Ants
              </h3>
            </div>
            <p class="description">I want to eliminate my anxiety regarding potential pests so that I can maintain a clean store image.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="" />
            <div class="title">
              <h3>Virus Prevention in Stores</h3>
            </div>
            <p class="description">I need reliable virus management because my store has a lot of customers.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_foodvirus.svg" alt="" />
            <div class="title">
              <h3>Food Freshness and Safety Management</h3>
            </div>
            <p class="description">I’m concerned about foreign materials and potential food poisoning in food courts or foods for sale.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>CESCO supports creating a hygienic environment in our stores, ensuring that customers can visit with confidence.</h4>
            <p>
              Maintaining rigorous hygiene and building customer trust are as crucial as basic pest control. CESCO manages all hygiene aspects within
              the store and aids the success of retail operations with the trusted CESCO <br class="mo_show" />Certification Mark.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/retail/border_content_01.png" alt="" />
          </div>
          <div>
            <img src="@/assets/images/location/retail/border_content_02.png" alt="" />
          </div>
          <div class="border-content">
            <h4>We offer specialized personnel and systems that deliver CESCO science effectively.</h4>
            <p>
              Proper usage of well-crafted equipment and chemicals is essential to achieve the best effects. CESCO ensures that our professionally
              trained personnel provide uniform service nationwide.
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>
        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" alt="" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Distribution Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_food.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Food Safety
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Systematic diagnostics and solutions for food safety</p>
            </div>

            <router-link to="/solution/service/food"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_01.png'),
    products: [
      {
        posX: '48.3125rem',
        posY: '7.375rem',
        mobilePosX: '64%',
        mobilePosY: '23%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_01.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_02.png'),
    products: [
      {
        posX: '42.5625rem',
        posY: '27.125rem',
        mobilePosX: '56%',
        mobilePosY: '73%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_02.png'),
          name: 'CESCO\nSmart Indoor Rodent Control Equipment Viper',
          description: 'Hygienically captures rats that enter business premises and monitors their movement and habitation with smart technology.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_03.png'),
    products: [
      {
        posX: '64.9375rem',
        posY: '16.5rem',
        mobilePosX: '85%',
        mobilePosY: '52%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_03.png'),
          name: 'CESCO\nAir Smart-Fit\nAir Purifier',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_04.png'),
    products: [
      {
        posX: '22.0625rem',
        posY: '17.25rem',
        mobilePosX: '34%',
        mobilePosY: '45%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_04.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_05.png'),
    products: [
      {
        posX: '58.4375rem',
        posY: '7.75rem',
        mobilePosX: '77%',
        mobilePosY: '23%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_05.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_06.png'),
    products: [
      {
        posX: '31.75rem',
        posY: '17.25rem',
        mobilePosX: '43%',
        mobilePosY: '55%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_06.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/retail/background_img_07.png'),
    products: [
      {
        posX: '37.0625rem',
        posY: '23.6537rem',
        mobilePosX: '49%',
        mobilePosY: '67%',
        productInfo: {
          image: require('@/assets/images/location/retail/product_img_07.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
